import { isWithinInterval } from "date-fns";

import { ReplayWindow, getReplayWindow } from "./get-replay-window";

/**
 * An item is in the replay window as long as the start is within the window.
 * @param start
 * @param now
 * @returns
 */
export function isWithinReplayWindow(
  start: Date,
  now: Date,
): { isInReplayWindow: boolean; replayWindow: ReplayWindow } {
  const replayWindow = getReplayWindow(now);

  return {
    replayWindow,
    isInReplayWindow: isWithinInterval(start, replayWindow),
  };
}
